import * as React from 'react'
import { Block, Division } from '$views/components'
import { Icon } from '$views/components/Icon'

const editIcon = require('$icons/pencil-reverse.svg')

interface Props {
  icon: string
  noDivision?: boolean
  onClick?: () => void
}

export const SummaryItem: React.SFC<Props> = ({ icon, children, noDivision, onClick }) => {
  return (
    <>
      <Block flex justify="between" marginTop="mini" marginBottom="mini">
        <Block flex>
          <Block marginRight="mini">
            <Icon content={icon} size="m" />
          </Block>
          <Block flex alignItems="end">
            {children}
          </Block>
        </Block>
        <Block marginLeft="mini">
          <Icon content={editIcon} size="m" color="menu" onClick={onClick} clickable />
        </Block>
      </Block>
      {!noDivision && <Division color="lightGrey" />}
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/RecommendationsForms/ResidenceForm/SummaryStep/components/SummaryItem.tsx